export default "__VITE_ASSET__63ce0161__"